import type { PersonEfteruddannelse } from "@/interfaces/schema";
import { EfteruddannelseIndberetningstypeId } from "@/interfaces/schema";

/**
 * Lektioner overført IND i perioden: fra forrige periode (Særlig) eller som overskud fra en
 * indfriet afgørelse.
 *
 * BEMÆRK at de gamle værdier Paabud og Paalaeg IKKE er med. De bæres af AMK-importerede
 * rækker med advokatens egen rapporterings form, og at de stod her fik AIKA til at vise
 * historiske indberetninger som overførsler. Se ADV-236.
 */
const TRANSFERRED_INDEBERETNING_TYPES = new Set([
  EfteruddannelseIndberetningstypeId.Saerlig,
  EfteruddannelseIndberetningstypeId.PaabudOverfoert,
  EfteruddannelseIndberetningstypeId.PaalaegOverfoert,
]);

export const getTransferredIndberetninger = (period: PersonEfteruddannelse) =>
  period.personEfteruddannelseIndberetning.filter((indberetning) =>
    TRANSFERRED_INDEBERETNING_TYPES.has(
      indberetning.efteruddannelseIndberetningstype,
    ),
  );
